const VendorIndex = () => import('@/views/Dashboard/SystemSettings/Vendor/VendorIndex');
const Vendors = () => import('@/views/Dashboard/SystemSettings/Vendor/View/Grid/VendorGrid');
const VendorDetails = () => import('@/views/Dashboard/SystemSettings/Vendor/Details/VendorDetails');
const VendorCreate = () => import('@/views/Dashboard/SystemSettings/Vendor/Create/VendorCreate');
const VendorsEdit = () => import('@/views/Dashboard/SystemSettings/Vendor/Edit/VendorEdit');

export default {
  path: '/vendors',
  component: VendorIndex,
  children: [
    {
      path: '/',
      name: 'vendor-grid',
      component: Vendors,
      meta: { preserveTableState: true },
    },
    {
      path: 'vendor-show/:id',
      name: 'vendor-show',
      component: VendorDetails,
    },
    {
      path: 'create',
      name: 'vendor-create',
      component: VendorCreate,
    },
    {
      path: 'edit/:id',
      name: 'vendor-edit',
      component: VendorsEdit,
    },
  ],
};
